import Row from 'components/ui/Row';
import Col from 'components/ui/Col';
import { media } from 'helpers/MediaHelper';
import styled from 'styled-components';
import { AntdButton as Button } from '@yuhuinc/ui-library';

export const StyledColumn = styled(Col)`
  ${media.mobile`
  margin-top: 16px;
  padding: 0 !important;
`};
`;

export const StyledContainer = styled.div`
  padding: 24px;
  ${media.mobile`
    padding: 16px;
  `};
`;

export const StyledRow = styled(Row)`
  width: 100%;
  margin-bottom: ${(props) => props.mb || '21px'};
  margin-top: ${(props) => props.mt || '0px'};
  ${media.mobile`
    margin: 0 !important;
    padding: 0 !important;
  `};
`;

export const StyledButton = styled(Button)`
  margin-right: 16px;
`;

export const LeaseSummaryColumnContent = styled.div`
  font-style: normal;
  font-weight: normal;
  font-size: 1.2rem;
  margin: 3px 0 8px 0;
  ${media.mobile`
    font-size: 16px;
  `};
`;

export const LeaseSummaryColumnTitle = styled.div`
  font-style: normal;
  font-weight: bold;
  font-size: 1.2rem;
  line-height: 22px;
  ${media.mobile`
    font-size: 16px;
  `};
`;
